import React from 'react';
import { DjangoListResponse, User, ItemList } from 'v2/models';
import {
  IAppliedFilter,
  EFilterOperations,
} from 'v2/common/ComposeFilters/filters';
import classnames from 'classnames';
import styles from './entityOwnerFilterDescription.module.scss';
import { useQuery } from 'react-query';
import restFactory from 'v2/utils/restFactory';
import { Spinner } from 'react-bootstrap';

interface EntityOwnerFilterDescriptionProps {
  filter: IAppliedFilter;
}

const filterOperationDisplayNames: Record<string, string> = {
  [EFilterOperations.equals]: 'is',
  [EFilterOperations.notEquals]: 'is not',
  [EFilterOperations.known]: 'is known',
  [EFilterOperations.unknown]: 'is unknown',
};

export const EntityOwnerFilterDescription = ({
  filter,
}: EntityOwnerFilterDescriptionProps) => {
  const value = filter.value as ItemList;
  const selectedUsersIds = value?.list.map((user) => user.id);

  const { data, isLoading } = useQuery(
    ['entityOwners', { selectedUsersIds }],
    async () => {
      return await restFactory.get<DjangoListResponse<User>>(
        '/dj/api/v1/strapi_user/',
        { id__in: selectedUsersIds.join(',') }
      );
    }
  );

  return (
    <span className={classnames(styles.appliedFilterDescription)}>
      {isLoading ? (
        <Spinner animation="border" data-testid="appliedFiltersSpinner" />
      ) : (
        <>
          <span className={classnames(styles.filtername)}>
            {filter.field.displayName}{' '}
          </span>
          {filterOperationDisplayNames[filter.operation]}{' '}
          {value?.is_all
            ? '- All users selected'
            : value?.list.map((user, index) => {
                const userData = data?.results.find(
                  (userData) => userData.id === user.id
                );
                const userName = `${userData?.first_name || ''} ${
                  userData?.last_name || ''
                }`;
                return (
                  <span key={`${user.id}`}>
                    <b>{userName}</b>
                    {index < value?.list.length - 1 && ' or '}
                  </span>
                );
              })}
        </>
      )}
    </span>
  );
};
